function FinancialPlanningNavIcon({ color }: { color?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" id="financial-planning">
      <path
        fill={color || '#8E33FF'}
        d="M10 1.666a8.333 8.333 0 100 16.667 8.333 8.333 0 000-16.667zm0 15a6.667 6.667 0 110-13.334 6.667 6.667 0 010 13.334z"
      ></path>
      <path
        fill={color || '#8E33FF'}
        d="M12.25 6.991L9.1 11.158 7.742 9.399a.834.834 0 00-1.317 1.025l2.025 2.592a.833.833 0 001.025.23.833.833 0 00.292-.238l3.808-5a.838.838 0 00-1.333-1.017h.008z"
      ></path>
    </svg>
  );
}

export default FinancialPlanningNavIcon;
